import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { WindowService } from '../window.service';
import { EduSynchModalService } from './edusynch-modal.service';

@Component({
  selector: 'lp2-edusynch-modal',
  templateUrl: './edusynch-modal.component.html',
  styleUrls: ['./edusynch-modal.component.scss'],
})
export class EduSynchModalComponent implements OnInit {
  error = null;
  constructor(
    public activeModal: NgbActiveModal,
    private readonly windowService: WindowService,
    private readonly eduSynchService: EduSynchModalService,
  ) {}

  ngOnInit() {
    this.eduSynchService.getUrl()
    .subscribe((url) => {
      if (!url) {
        return;
      }
      this.windowService.openUrl(url);
      this.activeModal.close();
    }, (error) => {
      this.error = error;
    });
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/edusynch-modal/edusynch-modal.component.ts